export const _jp2MimeTypes = ["image/jp2"];
